import Vue from 'vue';

export default new Vue({
    methods: {
        emitEndereco (obj) {
            this.$emit('editarEndereco', obj)
        }, 
        onEndereco(obj) {
            this.$on('editarEndereco', obj);
        },
        emitCentralizarMapa() {
            this.$emit('centralizarMapa');
        },
        onCentralizarMapa() {
            this.$on('centralizarMapa');
        }
    }
});